import React from "react";

import ImageCropUpload, {
  AspectOption,
  OutputBox,
  originalAspect,
} from "../imageCropUpload";

type Props = {
  value?: string | null;
  existingUrl?: string | null;
  onChange: (value: string | null) => void;
};

const aspectOptions: AspectOption[] = [
  { label: "મૂળ", value: originalAspect },
  { label: "1:1", value: 1 },
  { label: "4:3", value: 4 / 3 },
  { label: "3:4", value: 3 / 4 },
];

const outputBox: OutputBox = { width: 1024, height: 1024 };

const ItemPhoto = ({ value, existingUrl, onChange }: Props) => (
  <ImageCropUpload
    label="ફોટો"
    value={value && value.startsWith("data:") ? value : null}
    existingImageUrl={value && !value.startsWith("data:") ? existingUrl : null}
    onChange={onChange}
    aspectOptions={aspectOptions}
    outputBox={outputBox}
    outputType="image/jpeg"
    maxFileSizeMb={20}
    allowCamera
  />
);

export default ItemPhoto;
